export default "__VITE_ASSET__0t_HVXGE__"